export default "__VITE_ASSET__C9_Q7mj6__"